import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { TableColumnConfig } from 'src/app/core/interfaces/table-column-config';
import { Unit } from 'src/app/core/interfaces/unit';
import { UnitsService } from 'src/app/core/services/units/units.service';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent implements OnChanges {
  @Input() column: TableColumnConfig;
  @Input() rows: UntypedFormArray;
  @Input() formName: string;
  @Input() triggerChanges = false;
  @Output() updatedUnits = new EventEmitter<TableColumnConfig>();

  loadedColUnits = false;

  constructor(private unitsService: UnitsService) {}

  ngOnChanges(): void {
    this.loadTableUnits();
  }

  loadTableUnits(): void {
    if (!this.column?.quantity || !this.rows || !this.formName) {
      return;
    }

    this.column.currentUnit = this.unitsService.getFieldUnit(
      this.formName,
      this.column.relatedField,
      this.column.quantity,
    );
    this.loadedColUnits = true;
  }

  setFieldUnit(event: Unit): void {
    this.column.visibleDropdown = false;
    this.column.currentUnit = event;
    this.rows?.controls.forEach((row, index) => {
      const relatedField = row.get(this.column.relatedField);
      if (!relatedField) {
        return;
      }
      const isLast = index === this.rows.length - 1;
      const newValue = this.unitsService.transform(
        this.formName,
        this.column.relatedField,
        this.column.quantity,
        event.reference,
        relatedField.value,
        isLast,
      );
      const eventConfig = this.triggerChanges ? {} : { emitEvent: false };
      relatedField.setValue(newValue, eventConfig);
    });
    this.updatedUnits.emit(this.column);
  }
}
